import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

interface BannerConfig {
    enabled: boolean;
    text: string;
    color: string;
}

const fetchBannerConfig = async (): Promise<BannerConfig> => {
    const response = await api.get<BannerConfig>('/public/domain/environment-banner');
    return response.data;
};

const EnvironmentBanner: React.FC = () => {
    const { data: config } = useQuery({
        queryKey: ['environment-banner'],
        queryFn: fetchBannerConfig,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });

    const isDev = import.meta.env.DEV;
    const isStaging = import.meta.env.VITE_APP_ENV === 'homologacao' || import.meta.env.MODE === 'staging';

    if (config) {
        if (!config.enabled) return null;
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 99999,
                    backgroundColor: config.color || '#f59e0b',
                    color: '#fff',
                    textAlign: 'center',
                    padding: '2px 0',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                    pointerEvents: 'none',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
            >
                {config.text || 'AMBIENTE DE HOMOLOGAÇÃO'}
            </div>
        );
    }

    if (!isDev && !isStaging) return null;

    const text = isDev ? 'AMBIENTE DE DESENVOLVIMENTO' : 'AMBIENTE DE HOMOLOGAÇÃO';

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 99999,
                backgroundColor: '#f59e0b', // amber-500
                color: '#fff',
                textAlign: 'center',
                padding: '2px 0',
                fontSize: '12px',
                fontWeight: 'bold',
                letterSpacing: '1px',
                pointerEvents: 'none',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
        >
            {text}
        </div>
    );
};

export default EnvironmentBanner;
